import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import moment from 'moment';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import './ProduccionMensualGarantia.css'
import { userHasRole } from 'helpers/helpers';
import {
  CORREDOR_GP_CHANGE_FILTER_DATE,
  CORREDOR_GP_CHANGE_PROD_MENSUAL_FILTER_DATE
} from '../../../redux-store/constants/action-types';
import {
  cellNumOperation,
  cellOperation,
  headerOperation
} from '../../../helpers/tables';
import BaseTable from '../../shared/BaseTable';
import DownloadBtn from '../../shared/DownloadBtn';
import CorredorEndosoSummary from '../CorredorEndosoSummary';
import { getPoliciesPorMes } from '../../../redux-store/actions/corredorGarantia';
import MonthRangeFilter from '../../shared/MonthRangeFilter';
import { FRONT_MF, ROLES_CORREDOR_COMISIONES } from '../../../CONST';




class ProduccionMensualGarantia extends Component {

  componentDidMount() {
    const { dispatch, datesFilter, corredor } = this.props;
    dispatch(getPoliciesPorMes(datesFilter, corredor));
  }

  componentDidUpdate(prevProps) {
    const {
      datesFilter: { startDate: prevStartDate, endDate: prevEndDate },
      corredor: prevCorredor,
    } = prevProps;
    const { dispatch, datesFilter, datesFilter: { startDate, endDate }, corredor } = this.props;

    const datesChanged = startDate !== prevStartDate || endDate !== prevEndDate
    const corredorChanged = JSON.stringify(prevCorredor) !== JSON.stringify(corredor)

    if (datesChanged || corredorChanged) {
      dispatch(getPoliciesPorMes(datesFilter, corredor));
    }
  }

  render() {
    const {
      dispatch, history, user, loading, prodMensualList,
      summary, datesFilter, xlsxUrl, pdfUrl,
    } = this.props;

    const columns = [
      {
        Header: headerOperation('Año'),
        id: 'ano',
        accessor: i => cellOperation(i.ano),
        sortable: false,
        minWidth: 100,
      },
      {
        Header: headerOperation('Mes'),
        id: 'mes',
        accessor: i => cellOperation(i.mes),
        sortable: false,
        minWidth: 100,
      },
      {
        Header: headerOperation('Moneda'),
        id: 'moneda',
        accessor: i => cellOperation(i.moneda),
        sortable: false,
        minWidth: 100,
      },
      {
        Header: headerOperation('Movimientos Emitidos'),
        id: 'endosos',
        accessor: i => cellOperation(i.endosos),
        sortable: false,
        minWidth: 150,
      },
      {
        Header: headerOperation('Monto Garantizado'),
        id: 'cobertura',
        accessor: i => cellNumOperation(i.monto_garantizado),
        minWidth: 140,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Prima Neta'),
        id: 'prima',
        accessor: i => cellNumOperation(i.prima_neta, 'float'),
        minWidth: 100,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Comisión'),
        id: 'comision',
        accessor: i => cellNumOperation(i.comision_generada, 'float'),
        minWidth: 100,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Acciones'),
        id: 'actions',
        Cell: row => {
          const dateStr = `${row.original.mes.toLowerCase()}-${row.original.ano}`;
          const date = moment(dateStr, FRONT_MF);
          return (
            <div
              className="table-cell"
              style={{ textAlign: 'center' }}
            >
              {row.index % 3 === 1 && (
                <span title="ver">
                  <Button
                    className="download"
                    style={{ verticalAlign: 'baseline' }}
                    onClick={() => {
                      dispatch({
                        type: CORREDOR_GP_CHANGE_FILTER_DATE,
                        payload: {
                          fieldName: 'startDate',
                          value: date
                        }
                      });
                      dispatch({
                        type: CORREDOR_GP_CHANGE_FILTER_DATE,
                        payload: {
                          fieldName: 'endDate',
                          value: date
                        }
                      });
                      history.push('/corredor/polizas-garantia');
                    }}
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </Button>
                </span>
              )}
            </div>
          )
        },
        filterable: false,
        sortable: false,
        minWidth: 90,
      },
    ];
    return (
      <div className='prod-mensual-garantia'>
        <div style={{ display: 'grid', gridTemplateColumns: '500px 700px', alignItems: 'start' }}>
          <div
            style={{
              display: 'grid', gridTemplateColumns: '65px auto', gridGap: '4px 15px',
              padding: '0 0 16px 16px', alignItems: 'center',
            }}
          >
            {!user.is_orsan && (
              <>
                <div className="orsan-label">Nombre:</div>
                <div className="orsan-value">{user.organization_name}</div>
                <div className="orsan-label">RUT:</div>
                <div className="orsan-value">{user.organization_rut}</div>
              </>
            )}
            <div className="orsan-label">Desde:</div>
            <MonthRangeFilter
              dispatch={dispatch}
              datesFilter={datesFilter}
              changeDateActionName={CORREDOR_GP_CHANGE_PROD_MENSUAL_FILTER_DATE}
            />
          </div>
          <div>
            <CorredorEndosoSummary
              data={summary}
              columns={[
                { title: 'Moneda', accessor: 'moneda', format: 'string' },
                { title: 'Monto Garantizado Período', accessor: 'monto_garantizado', format: 'number', cellAlign: 'right' },
                { title: 'Prima Neta Período', accessor: 'prima_neta', format: 'number', cellAlign: 'right' },
                { title: 'Comisión Período', accessor: 'comision_generada', format: 'number', cellAlign: 'right' },
              ]}
            />
          </div>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto max-content max-content max-content',
            gridGap: '10px',
            marginTop: '15px',
            marginBottom: '6px',
          }}
        >
          <div />
          {userHasRole(user, ROLES_CORREDOR_COMISIONES) && (
            <div>
              <Button
                style={{ fontSize: '14px' }}
                disabled
              >
                Ir a Liquidación de Comisiones
              </Button>
            </div>
          )}
          <div>
            <DownloadBtn
              id='xlsx-download'
              text='XLSX'
              tipText='Descargar Planilla Excel'
              url={xlsxUrl}
            />
          </div>
          <div>
            <DownloadBtn
              id='pdf-download'
              text='PDF'
              tipText='Descargar PDF'
              disabled={!pdfUrl}
              url={pdfUrl}
            />
          </div>
        </div>
        <BaseTable
          columns={columns}
          data={prodMensualList}
          loading={loading}
          style={{ maxHeight: '63vh' }}
        />
      </div>
    );
  }
}

ProduccionMensualGarantia.propTypes = {
  dispatch: PropTypes.func.isRequired,
  prodMensualList: PropTypes.arrayOf(
    PropTypes.shape({
      ano: PropTypes.number,
      mes: PropTypes.string,
      endosos: PropTypes.number,
      monto_garantizado: PropTypes.number,
      prima_neta: PropTypes.number,
      comision_generada: PropTypes.number,
    }),
  ).isRequired,
  xlsxUrl: PropTypes.string.isRequired,
  pdfUrl: PropTypes.string.isRequired,
  datesFilter: PropTypes.shape({
    startDate: PropTypes.instanceOf(moment),
    endDate: PropTypes.instanceOf(moment),
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  summary: PropTypes.array,
  poliza: PropTypes.shape({
    monedas: PropTypes.array,
    tiposCobertura: PropTypes.array,
  }).isRequired,
  user: PropTypes.shape({
    organization_name: PropTypes.string,
    organization_rut: PropTypes.string,
    is_orsan: PropTypes.bool,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  corredor: PropTypes.shape({
    id: PropTypes.number,
  })
};

ProduccionMensualGarantia.defaultProps = {
  summary: null,
  corredor: null,
};

const mapStateToProps = state => ({
  prodMensualList: state.corredorGarantia.prodMensual.list,
  datesFilter: state.corredorGarantia.prodMensual.datesFilter,
  xlsxUrl: state.corredorGarantia.prodMensual.xlsxUrl,
  pdfUrl: state.corredorGarantia.prodMensual.pdfUrl,
  summary: state.corredorGarantia.prodMensual.summary,
  loading: state.corredorGarantia.loading,
  poliza: state.poliza,
  user: state.login.user,
});

export default connect(mapStateToProps)(ProduccionMensualGarantia);
